import { render, staticRenderFns } from "./NavEventCalendarMobile.vue?vue&type=template&id=96dd0508&"
import script from "./NavEventCalendarMobile.vue?vue&type=script&lang=js&"
export * from "./NavEventCalendarMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports